import { IP } from '../../configuracion.js';

export const printUSBTicket = async (
  order,
  total,
  appliedPayments,
  property,
  deviceConfig,
  selectedRevenue,
  selectedSpace,
  chequeSeleccionado,
  currentUser,
  printerConfig
) => {
  let endpoint = '';
  let requestData = {};
  let sanitizedProperty = '';

  try {
    console.log('[USBPrinter] Iniciando impresión',
      printerConfig?.isCorte ? 'de corte de caja' :
      printerConfig?.isCuentaCliente ? 'de cuenta por cliente' :
      printerConfig?.esQR ? 'de código QR' :
      'de ticket');

    console.log('[USBPrinter] QR Flags:', {
      isQR: printerConfig.isQR,
      esQR: printerConfig.esQR
    });
    console.log('[USBPrinter] printerConfig:', JSON.stringify(printerConfig, null, 2));
    console.log('[USBPrinter] deviceConfig:', JSON.stringify(deviceConfig, null, 2));
    console.log('[USBPrinter] currentUser:', JSON.stringify(currentUser, null, 2));
    console.log('[USBPrinter] order:', JSON.stringify(order, null, 2));

    if (!printerConfig || typeof printerConfig !== 'object') {
      console.warn('[USBPrinter] printerConfig no proporcionado o inválido, usando valores predeterminados');
      printerConfig = {};
    }

    const deviceID = printerConfig.DeviceID ||
                    printerConfig.USB?.DeviceID ||
                    deviceConfig?.PRNTT || 'tavpos';

    printerConfig.DeviceID = deviceID;
    printerConfig.USB = {
      ...printerConfig.USB,
      DeviceID: deviceID,
      Tipo: 'USB'
    };

    console.log('[USBPrinter] Configuración de impresora:', {
      DeviceID: printerConfig.DeviceID,
      Tipo: printerConfig.USB?.Tipo || 'USB'
    });

    try {
      if (property === undefined || property === null) {
        throw new Error('La propiedad no fue proporcionada');
      }

      const propertyStr = String(property).trim();
      if (propertyStr === '') {
        throw new Error('La propiedad está vacía');
      }

      sanitizedProperty = propertyStr.replace(/[^a-zA-Z0-9-]/g, '');

      if (sanitizedProperty.includes('..') || sanitizedProperty.includes('/')) {
        throw new Error('La propiedad contiene caracteres no permitidos');
      }

      if (sanitizedProperty !== propertyStr) {
        console.log('[USBPrinter] Property original:', propertyStr, 'Sanitizado:', sanitizedProperty);
      }
    } catch (propError) {
      console.error('[USBPrinter] Error al procesar la propiedad:', propError);
      throw new Error(`Propiedad inválida: ${propError.message}`);
    }

    if (printerConfig.esQR) {
      console.log('[USBPrinter] QR Data:', {
        qrCode: order[0]?.qrCode,
        cliente: printerConfig.cliente,
        cheque: chequeSeleccionado
      });
      try {
        if (!order || !Array.isArray(order) || order.length === 0) {
          throw new Error('Datos del pedido no válidos para generar QR');
        }
        if (!printerConfig.cliente) {
          throw new Error('El número de cliente no fue proporcionado');
        }
        if (!chequeSeleccionado) {
          throw new Error('El número de cheque no fue proporcionado');
        }

        const clienteNumber = parseInt(printerConfig.cliente, 10);
        if (isNaN(clienteNumber) || clienteNumber <= 0) {
          throw new Error('El número de cliente debe ser un número positivo');
        }

        const chequeNumber = parseInt(chequeSeleccionado, 10);
        if (isNaN(chequeNumber) || chequeNumber <= 0) {
          throw new Error('El número de cheque debe ser un número positivo');
        }

        console.log('[USBPrinter] Datos validados para QR - Cheque:', chequeNumber, 'Cliente:', clienteNumber);
        
        endpoint = `${IP}/tavpos/backend/data/${sanitizedProperty}/print_qr.php`;

        requestData = {
          property: sanitizedProperty,
          qrCode: order[0]?.qrCode || undefined, // Optional, backend should generate QR
          cheque: chequeNumber,
          cliente: clienteNumber,
          header: `Cuenta Cliente ${printerConfig.cliente}`,
          footer: `Cheque #${chequeSeleccionado} - Mesa: ${selectedSpace?.name || order[0]?.mesa || 'N/A'}`,
          printer: deviceID,
          usuario: currentUser?.nombre || 'Desconocido',
          total: total || 0,
          productos: order.map(item => ({
            nombre: item.nombre || 'Producto',
            cantidad: item.cantidad || 1,
            precio: item.precio || 0,
            comentarios: item.comentarios || ''
          })),
          revenue: selectedRevenue?.name || 'Revenue',
          _debug: {
            originalProperty: property,
            originalCheque: chequeSeleccionado,
            timestamp: new Date().toISOString()
          }
        };
      } catch (validationError) {
        console.error('[USBPrinter] Error en validación de QR:', validationError);
        throw new Error(validationError.message);
      }
    } else if (printerConfig.isCorte) {
      let usuario;
      try {
        if (!printerConfig.corteData) {
          throw new Error('Los datos del corte no fueron proporcionados');
        }
        if (!printerConfig.fecha_control) {
          throw new Error('La fecha de control no fue proporcionada');
        }

        let corteDataObj;
        try {
          corteDataObj = JSON.parse(printerConfig.corteData);
        } catch (jsonError) {
          throw new Error('Formato de corteData inválido');
        }

        usuario = corteDataObj.usuario || currentUser?.nombre || currentUser?.id || 'Desconocido';
        if (!usuario || usuario === 'Desconocido') {
          console.warn('[USBPrinter] No se pudo determinar el usuario, usando "Desconocido"');
        }
      } catch (corteError) {
        console.error('[USBPrinter] Error al procesar los datos del corte:', corteError);
        throw new Error(`Datos de corte inválidos: ${corteError.message}`);
      }

      requestData = {
        property: sanitizedProperty,
        usuario: usuario,
        printer: deviceID,
        fecha_control: printerConfig.fecha_control,
        corteData: printerConfig.corteData
      };

      endpoint = `${IP}/tavpos/backend/data/${sanitizedProperty}/cortecajaprt.php`;
    } else if (printerConfig.isCuentaCliente) {
      let chequeNumber, clienteNumber;
      try {
        if (chequeSeleccionado === undefined || chequeSeleccionado === null) {
          throw new Error('El número de cheque no fue proporcionado');
        }
        chequeNumber = parseInt(chequeSeleccionado, 10);
        if (isNaN(chequeNumber) || chequeNumber <= 0) {
          throw new Error('El número de cheque debe ser un número positivo');
        }

        if (!printerConfig.cliente) {
          throw new Error('El número de cliente no fue proporcionado');
        }
        clienteNumber = parseInt(printerConfig.cliente, 10);
        if (isNaN(clienteNumber) || clienteNumber <= 0) {
          throw new Error('El número de cliente debe ser un número positivo');
        }

        console.log('[USBPrinter] Datos validados - Cheque:', chequeNumber, 'Cliente:', clienteNumber);
      } catch (validationError) {
        console.error('[USBPrinter] Error en validación:', validationError);
        throw new Error(validationError.message);
      }

      endpoint = `${IP}/tavpos/backend/data/${sanitizedProperty}/ticketscte.php?cliente=${clienteNumber}`;

      requestData = {
        property: sanitizedProperty,
        cheque: chequeNumber,
        cliente: clienteNumber,
        printer: deviceID,
        mesa: selectedSpace?.name || 'Mesa',
        revenue: selectedRevenue?.name || 'Revenue',
        usuario: currentUser?.nombre || 'Desconocido',
        _debug: {
          originalProperty: property,
          originalCheque: chequeSeleccionado,
          timestamp: new Date().toISOString()
        }
      };
    } else {
      let chequeNumber;
      try {
        if (chequeSeleccionado === undefined || chequeSeleccionado === null) {
          throw new Error('El número de cheque no fue proporcionado');
        }

        chequeNumber = parseInt(chequeSeleccionado, 10);
        if (isNaN(chequeNumber) || chequeNumber <= 0) {
          throw new Error('El número de cheque debe ser un número positivo');
        }
      } catch (chequeError) {
        console.error('[USBPrinter] Error al procesar el número de cheque:', chequeError);
        throw new Error(`Número de cheque inválido: ${chequeError.message}`);
      }

      requestData = {
        property: sanitizedProperty,
        cheque: chequeNumber,
        printer: deviceID,
        usuario: currentUser?.nombre || 'Desconocido',
        _debug: {
          originalProperty: property,
          originalCheque: chequeSeleccionado,
          timestamp: new Date().toISOString()
        }
      };

      endpoint = `${IP}/tavpos/backend/data/${sanitizedProperty}/tickets.php`;
    }

    console.log('[USBPrinter] Endpoint:', endpoint);
    console.log('[USBPrinter] Datos enviados:', JSON.stringify(requestData, null, 2));

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 15000);

    console.log('[USBPrinter] Enviando solicitud POST...');
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Origin': window.location.origin
      },
      body: JSON.stringify(requestData),
      mode: 'cors',
      signal: controller.signal
    }).finally(() => clearTimeout(timeoutId));

    console.log('[USBPrinter] Respuesta recibida:', {
      status: response.status,
      statusText: response.statusText
    });

    let responseData;
    try {
      responseData = await response.json();
      console.log('[USBPrinter] Respuesta JSON:', responseData);
    } catch {
      throw new Error('La respuesta del servidor no es un JSON válido');
    }

    if (!response.ok) {
      throw new Error(`Error HTTP ${response.status}: ${responseData.message || 'Error desconocido'}`);
    }

    if (responseData.success) {
      console.log('[USBPrinter] Impresión exitosa');
      return {
        success: true,
        message: responseData.message ||
               (printerConfig.esQR ? 'Código QR enviado a la impresora correctamente' :
                printerConfig.isCorte ? 'Corte enviado a la impresora correctamente' :
                printerConfig.isCuentaCliente ? 'Cuenta por cliente enviada a la impresora correctamente' :
                'Ticket enviado a la impresora correctamente'),
        data: responseData.data
      };
    } else {
      throw new Error(responseData.message ||
                    (printerConfig.esQR ? 'Error al generar el código QR' :
                     printerConfig.isCorte ? 'Error al generar el corte' :
                     printerConfig.isCuentaCliente ? 'Error al generar la cuenta por cliente' :
                     'Error al generar el ticket'));
    }
  } catch (error) {
    console.error('[USBPrinter] Error durante el proceso de impresión:', {
      error: error.message,
      stack: error.stack,
      inputParameters: {
        order: order ? '[...]' : 'null',
        total,
        appliedPayments: appliedPayments ? '[...]' : 'null',
        property,
        deviceConfig,
        selectedRevenue,
        selectedSpace,
        chequeSeleccionado,
        currentUser: currentUser ? '{...}' : 'null',
        printerConfig
      },
      endpoint: endpoint || 'no definido',
      requestData: requestData || {}
    });

    let userMessage = 'Error al enviar a la impresora USB';
    if (printerConfig?.esQR) {
      userMessage = 'Error al enviar el código QR a la impresora USB';
    } else if (printerConfig?.isCorte) {
      userMessage = 'Error al enviar el corte a la impresora USB';
    } else if (printerConfig?.isCuentaCliente) {
      userMessage = 'Error al enviar la cuenta por cliente a la impresora USB';
    }

    if (error.message.includes('Failed to fetch') || error.name === 'AbortError') {
      userMessage = 'No se pudo conectar con el servidor de impresión. Verifica la conexión.';
    } else if (error.message.includes('NetworkError')) {
      userMessage = 'Error de red al conectar con la impresora';
    } else if (error.message.includes('Configuración')) {
      userMessage = 'Configuración de impresora incorrecta';
    } else if (error.message.includes('Propiedad inválida')) {
      userMessage = 'Propiedad no válida para la impresión';
    } else if (error.message.includes('cheque') && !printerConfig.isCorte && !printerConfig.esQR) {
      userMessage = 'Número de cheque no válido';
    } else if (error.message.includes('corte') && printerConfig.isCorte) {
      userMessage = 'Datos del corte no válidos';
    } else if (error.message.includes('cliente') && (printerConfig.isCuentaCliente || printerConfig.esQR)) {
      userMessage = 'Datos del cliente no válidos';
    } else if (error.message.includes('QR') && printerConfig.esQR) {
      userMessage = 'Datos del código QR no válidos';
    }

    return {
      success: false,
      message: userMessage,
      error: error.message,
      details: process.env.NODE_ENV === 'development' ? {
        stack: error.stack,
        endpoint: endpoint,
        requestData: requestData
      } : null
    };
  }
};